var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"labeled-info"},[_c('span',{staticClass:"labeled-info__label"},[_vm._v(_vm._s(_vm.label))]),_c('div',{staticClass:"labeled-info__value long-text"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }